import { Navigate } from "react-router-dom";
import { LoginForm } from "./LoginForm"
import { useSelector } from "react-redux";

export default function LoginPage() {
    const { isLoginLoading } = useSelector((state) => state.auth);

    const token = window.localStorage.token
    let isAuthenticated = false

    if (token) {
        isAuthenticated = true
    }
    if (!isLoginLoading && isAuthenticated === true) {
        return <Navigate to="/admin" replace />;
    }
    return (
        <div className="min-h-screen flex items-center justify-center bg-background px-4">
            <div className="w-full max-w-md">
                <div className="text-center mb-8">
                    <h1 className="text-3xl font-bold text-foreground mb-2">Welcome Back</h1>
                    <p className="text-muted-foreground">Sign in to your account to continue</p>
                </div>
                <LoginForm />
            </div>
        </div>
    )
}
